import { useBlocker } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';

export const UnsavedChangesPopup = ({ readonly }) => {
  const [open, setOpen] = useState(false);
  const blocker = useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) => {
        const isDifferent = currentLocation.pathname !== nextLocation.pathname;
        const isConfiguration = currentLocation.pathname.includes('/configuration');

        return isConfiguration && !readonly && isDifferent;
      },
      [readonly],
    ),
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      onOpenChange(true);
    }
  }, [blocker]);

  const onOpenChange = (isOpen) => {
    setOpen(isOpen);
  };

  const onLeave = () => {
    blocker.proceed();
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent closeButtonHidden className={'py-7.5 !max-w-[450px] gap-1 bg-light'}>
        <DialogTitle>
          <p className={'text-center text-lg text-ebony font-semibold'}>
            You have unsaved changes!
          </p>
        </DialogTitle>
        <div className="sub-title flex items-center gap-3.5 w-full justify-center">
          <p className={'text-center text-sm text-ebony font-medium'}>
            Are you sure you want to leave this page?
            <br />
            Your changes will be lost.
          </p>
        </div>
        <DialogFooter className="max-md:flex-row max-md:gap-2.5 !justify-center flex w-full pt-6">
          <DialogClose asChild>
            <Button
              onClick={onLeave}
              variant="outline"
              className="transparent black min-w-28 flex flex-1"
            >
              Leave
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button className={'flex flex-1'}>Continue Editing</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
